/**
 * The content hue a space wears — `data-1` to `data-6` — wherever it is marked:
 * the editor's phase tabs, the event page's phases, the run sheet.
 *
 * By the space's order in the venue, not by what it is. Plan View assigns
 * content hues that way so a color never pretends to mean "outdoor" or
 * "dining", and keeps a space's hue the same on every screen — which is why it
 * is one function here rather than an index counted in each place: two
 * counts over two differently-filtered lists would give one room two colors.
 *
 * Ties on `sortOrder` fall to the id, so the answer does not depend on the
 * order the API happened to send. A seventh space wraps to the first hue: six
 * are as many as can be told apart at a glance, and the space's name is always
 * written beside its mark.
 */
export type SpaceHue = 1 | 2 | 3 | 4 | 5 | 6

const HUES: readonly SpaceHue[] = [1, 2, 3, 4, 5, 6]

export function spaceHues(spaces: readonly { id: string; sortOrder: number }[]): ReadonlyMap<string, SpaceHue> {
  const ordered = [...spaces].sort((a, b) => a.sortOrder - b.sortOrder || a.id.localeCompare(b.id))
  return new Map(ordered.map((space, index) => [space.id, HUES[index % HUES.length] ?? 1]))
}

/** The class that points an element's `--ds-data*` at a hue (`.ds-data-N` in `index.css`). */
export function spaceHueClass(hue: SpaceHue): string {
  return `ds-data-${String(hue)}`
}
